import { render } from "./page-bonus-spend.vue?vue&type=template&id=7550aff6&scoped=true"
import script from "./page-bonus-spend.vue?vue&type=script&lang=js"
export * from "./page-bonus-spend.vue?vue&type=script&lang=js"

import "./page-bonus-spend.vue?vue&type=style&index=0&id=7550aff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7550aff6"]])

export default __exports__